import {Box, Button, Grid, Typography} from '@material-ui/core/'
import useCore from 'modules/reports/hooks/core'
import React from 'react'
import useStyles from './ReportsIndexHeader.styles'

type Props = {
  title: React.ReactNode
  newHref: string
  newButtonText: React.ReactNode
}

function ReportsIndexHeader(props: Props) {
  const classes = useStyles()
  const {title, newHref, newButtonText} = props
  const {p} = useCore('reports', 'components', 'IndexHeader')

  return (
    <Box paddingX={4} paddingY={2}>
      <Grid
        container
        direction="row"
        justify="space-between"
        alignItems="center"
        component="header"
      >
        <Typography className={classes.title} variant="h6" component="h1" data-testid={p('title')}>
          {title}
        </Typography>

        <Button variant="contained" size="small" data-testid={p('new-button')} href={newHref}>
          {newButtonText}
        </Button>
      </Grid>
    </Box>
  )
}

export default ReportsIndexHeader
